/* Information component on the Budget Page */
   import React from 'react';
   import Row from "react-bootstrap/Row";
   import Col from "react-bootstrap/Col";
   import styles from "../../../styles/Account.module.css";
   
   const Information = () => {
     return (
       <div className="mb-5 px-3">
      <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center ${styles.Blue}`} >BUDGET INFO</h5>  
        <hr className={`mt-2 mb-0`}/>
        <p className={`pt-1`}><span className={`${styles.Blue}`}>*</span> To <span className={`${styles.Blue}`}>initialize</span> the Budget enter the Title and as many
            other Production Info details as you want on the Create Budget form then press Create.
        </p>
        <p className={`pt-1`}><span className={`${styles.Blue}`}>*</span> Once completed click the <span className={`${styles.Blue}`}>Edit</span> Budget button on the Budget page to add the main Budgets details.
            This may be used as many times as needed to create the 
            preliminary Budget, the Final Budget and all necessary
            Budgets in between.
        </p>  
        <p className={`pt-1`}><span className={`${styles.Blue}`}>*</span> Once you are happy with each one <span className={`${styles.Blue}`}>print</span> it off along with 
            it's Cover and Topsheet.
        </p>
        <p className={`pt-2 ${styles.Small}`}><span className={`${styles.Blue}`}>*</span> Note: For <span className={`${styles.Blue}`}>Platform Projects</span> click the Create Budget button to 
        open the Create Budget form.</p>
        <hr className={`mt-2 mb-0`}/>
        </div> 
        </Col>
      </Row>
    </div>
     )
   }

export default Information